export default "__VITE_ASSET__CO8GDzQt__"